import { GetSiteLegionellaSensorRoomMapResponseSchema } from '@shared/schema/site.legionella-sensor-room-map.schema'
import { queryOptions } from '@tanstack/react-query'

import { QueryOptionsData } from '@/@types/query'
import { SiteId } from '@/@types/site'
import { apiFetch } from '@/lib/api-fetch'

export function legionellaSensorRoomMapQuery(siteId: SiteId) {
  return queryOptions({
    queryKey: ['site', 'legionella', 'sensor', 'room-map', siteId],
    async queryFn() {
      const rawResponse = await apiFetch.get(`site/${siteId}/legionella/sensor-room-map`)

      if (!rawResponse.ok) {
        throw new Error(`Failed to fetch legionella sensor room map for site ${siteId}`)
      }

      try {
        return GetSiteLegionellaSensorRoomMapResponseSchema.parse(await rawResponse.json())
      } catch (error) {
        throw new Error('Failed to parse legionella sensor room map response', { cause: error })
      }
    },
  })
}

export type LegionellaSensorRoomMap = QueryOptionsData<typeof legionellaSensorRoomMapQuery>
